export default {
  today: "Aujourd'hui",
  yesterday: 'Hier',
};
